import { useQuery } from "react-query"
import API from "../../../services/API"
import { useContext } from "react"
import UserContext from "../../../services/Context/UserContext"

export default function usePacks(){

    const { user } = useContext(UserContext)

    return useQuery({

        queryKey: ['packs'],

        queryFn: () => API.get(`/products?type=pack`)
            .then(r => r.data.filter(p => p.category?.id === user.category.id)) 
    })

}